import { toCanvas, toBlob, toPixelData, toPng, toJpeg, toSvg } from 'html-to-image'

export class ExportService {
  async toImage (ref, ext, { cacheBust = true, width, height } = {}) {
    const options = { cacheBust, width, height }

    switch (ext) {
      case 'canvas':
        return toCanvas(ref, options)
      case 'blob':
        return toBlob(ref, options)
      case 'jpeg':
        return toJpeg(ref, options)
      case 'pixel':
        return toPixelData(ref, options)
      case 'png':
        return toPng(ref, options)
      case 'svg':
        return toSvg(ref, options)
      default:
        throw new Error('Unsupported file type')
    }
  }
}

export const exportService = new ExportService()
